import React, { Component } from 'react';
import classNames from 'classnames';

import i18n from '../../config/i18n';
import Link from '../../components/shared/Link';
import connectActionsAndReducers from '../../toolbox/connectActionsAndReducers';
import {
  REGEX_PASSWORD,
  REGEX_PASSWORD_LENGTH,
  REGEX_PASSWORD_LOWERCASE,
  REGEX_PASSWORD_UPPERCASE,
  REGEX_PASSWORD_NUMBER,
} from '../../toolbox/regex';
import { ForgotPasswordAPIConnectors } from '../../api/index';
import {
  ACCESS_TOKEN,
  ACCESS_TOKEN_EXPIRE_TIME,
} from '../../constants/localStorageKeys';

const styles = {
  button: {
    cancel: {
      marginRight: 10,
    },
  },
};

class EditPasswordContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isValid: false,
      shouldRedirect: false,
      newPassword: '',
      currentPassword: '',
      confirmPassword: '',
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.checkPasswordRuleLength = this.checkPasswordRuleLength.bind(this);
    this.checkPasswordRuleLowercase = this.checkPasswordRuleLowercase.bind(this);
    this.checkPasswordRuleUppercase = this.checkPasswordRuleUppercase.bind(this);
    this.checkPasswordRuleNumber = this.checkPasswordRuleNumber.bind(this);
    this.checkPasswordsMatch = this.checkPasswordsMatch.bind(this);
  }

  onSubmit(e) {
    e.preventDefault();
    const {
      isValid,
      newPassword,
    } = this.state;
    const {
      user: {
        accessToken,
        userId,
      },
      actions,
    } = this.props;

    if (isValid) {
      // disable change password button
      this.setState({ isValid: false });
      ForgotPasswordAPIConnectors.updatePassword(userId, newPassword, accessToken)
        .then(() => {
          actions.createSuccessAlert(i18n.t('resetPwdSucceedMsg'));
          localStorage.removeItem(ACCESS_TOKEN);
          localStorage.removeItem(ACCESS_TOKEN_EXPIRE_TIME);
          setTimeout(() => {
            window.location = '/login';
          }, 2000);
        })
        .catch((err) => {
          this.props.actions.createDangerAlert(i18n.t('wrongPwdMsg'), err.messages);
          this.setState({
            currentPassword: '',
            newPassword: '',
            confirmPassword: '',
            isValid: false,
          });
        });
    }
  }

  handleInputChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  // at least 1 number, 1 lowercase, 1 uppercase, and at least 7 characters
  checkPasswordRule = str => REGEX_PASSWORD.test(str);

  checkPasswordRuleLength = str => REGEX_PASSWORD_LENGTH.test(str);

  checkPasswordRuleLowercase = str => REGEX_PASSWORD_LOWERCASE.test(str);

  checkPasswordRuleUppercase = str => REGEX_PASSWORD_UPPERCASE.test(str);

  checkPasswordRuleNumber = str => REGEX_PASSWORD_NUMBER.test(str);

  checkPasswordsMatch(value) {
    const match = this.state.newPassword === value;
    const isValid = this.checkPasswordRule(this.state.newPassword);

    if (match && isValid) {
      if (!this.state.isValid) {
        this.setState({ isValid: true });
      }
    } else if (this.state.isValid) {
      this.setState({ isValid: false });
    }
    return value !== '' && match;
  }

  render() {
    const {
      newPassword,
      confirmPassword,
    } = this.state;
    const userEmail = this.props.user.profile.email;
    const passwordRuleLength = this.checkPasswordRuleLength(newPassword);
    const passwordRuleLowercase = this.checkPasswordRuleLowercase(newPassword);
    const passwordRuleUppercase = this.checkPasswordRuleUppercase(newPassword);
    const passwordRuleNumber = this.checkPasswordRuleNumber(newPassword);
    const passwordMatched = this.checkPasswordsMatch(confirmPassword);
    const formValid = passwordMatched && this.checkPasswordRule(newPassword);

    return (
      <div>
        <h1>
          {i18n.t('changePwd')}
        </h1>
        <p>
          {i18n.t('plzEnterNewPwdMsg', { userEmail })}
        </p>
        <form
          ref={(ref) => { this.passwordForm = ref; }}
          onSubmit={this.onSubmit}
          autoComplete="off"
        >
          <div className="form-group">
            <label
              className="control-label"
              htmlFor="currentPassword"
            >
              {i18n.t('currentPwd')}
            </label>
            <input
              name="currentPassword"
              className="form-control"
              placeholder={i18n.t('currentPwd')}
              type="password"
              value={this.state.currentPassword}
              onChange={this.handleInputChange}
              required
            />
          </div>
          <div className="form-group">
            <label className="control-label" htmlFor="password">
              {i18n.t('newPwd')}
            </label>
            <input
              name="newPassword"
              className="form-control"
              placeholder={i18n.t('newPwd')}
              type="password"
              value={this.state.newPassword}
              onChange={this.handleInputChange}
              required
            />
            <div className="help-block">
              <span className={classNames('help-block', passwordRuleLength ? 'text-success' : 'text-danger')}>
                {i18n.t('atLeast7Char')}
              </span>
              <span className={classNames('help-block', passwordRuleLowercase ? 'text-success' : 'text-danger')}>
                {i18n.t('atLeast1LowerChar')}
              </span>
              <span className={classNames('help-block', passwordRuleUppercase ? 'text-success' : 'text-danger')}>
                {i18n.t('atLeast1UpperChar')}
              </span>
              <span className={classNames('help-block', passwordRuleNumber ? 'text-success' : 'text-danger')}>
                {i18n.t('atLeast1Num')}
              </span>
            </div>
          </div>
          <div className="form-group">
            <label className="control-label" htmlFor="confirmPassword">
              {i18n.t('newPwdConfirm')}
            </label>
            <input
              name="confirmPassword"
              className="form-control"
              placeholder={i18n.t('newPwdConfirm')}
              type="password"
              value={this.state.confirmPassword}
              onChange={this.handleInputChange}
              required
            />
            <div>
              <span className={classNames('help-block', passwordMatched ? 'text-success' : 'text-danger')}>
                {i18n.t('pwdNotMatch')}
              </span>
            </div>
          </div>
          <div className="form-group clearfix">
            <button disabled={!formValid} className="btn btn-info pull-right">
              {i18n.t('changePwd')}
            </button>
            <Link href="/profile/edit" router={this.props.router}>
              <button type="button" className="btn btn-primary pull-right" style={styles.button.cancel}>
                {i18n.t('cancel')}
              </button>
            </Link>
          </div>
        </form>
      </div>
    );
  }
}

export default connectActionsAndReducers(EditPasswordContainer);



// WEBPACK FOOTER //
// ./src/containers/profile/EditPasswordContainer.js